const state = {
  products: [],
  product: {}
};

export default {
  namespaced: true,
  state,
  mutations: {
    setProducts(state, products) {
      state.products = products;
    },
    setProduct(state, product) {
      state.product = product;
    }
  },
  actions: {
    fetchProducts({ commit }, payload) {
      const { dontPaginate, filter, paginationcount } = payload;
      if (!!dontPaginate || typeof dontPaginate === 'undefined') {
        commit('SET_LOADING', true, { root: true });
        if (!!filter || typeof filter === 'undefined') {
          return axios
            .get('api/v1/product', {
              params: { page: payload.page, filter: filter, paginationcount: paginationcount }
            })
            .then(response => {
              commit('setProducts', response.data);
            })
            .catch(error => {
              if (error.response.status == 403) {
                commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              }
            })
            .finally(() => commit('SET_LOADING', false, { root: true }));
        }
        return axios
          .get('api/v1/product', {
            params: { page: payload.page, paginationcount: paginationcount }
          })
          .then(response => {
            commit('setProducts', response.data);
          })
          .catch(error => {
            if (error.response.status == 403) {
              commit(
                'SET_SNACK_BAR',
                {
                  message: error.response.data['message'],
                  color: 'error'
                },
                { root: true }
              );
            }
          })
          .finally(() => commit('SET_LOADING', false, { root: true }));
      } else {
        return axios.get('api/v1/product', { params: { paginate: 0 } }).then(response => {
          commit('setProducts', response.data);
        });
      }
    },
    getProduct({ commit }, payload) {
      return axios
        .get(`api/v1/product/${payload.id}`)
        .then(response => {
          commit('setProduct', response.data);
        })
        .catch(error => {
          if (error.response.status == 403) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setProduct', {});
          }
        })
        .catch(error => {
          if (error.response.status == 404) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setProduct', {});
          }
        });
    }
  }
};
